export * from './daily-section-stats.pipe';
